import { Box, FormControl, MenuItem, Select } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const StatusDropDownStatus = ({
  handleChange,
  selectedStatus,
  dropdownOptions = [
    { label: "Pending", value: "draft" },
    { label: "Completed", value: "completed" },
    { label: "Rejected", value: "revoked" },
  ],
  disabled = false,
  showInfoText = true,
  sx = {},
}) => {
  return (
    <FormControl
      sx={{
        width: "100%",
        minWidth: "100px",
        ...sx, // Apply dynamic styles
      }}
      disabled={disabled}
    >
      <Select
        value={selectedStatus}
        onChange={handleChange}
        displayEmpty
        IconComponent={KeyboardArrowDownIcon}
        sx={{
          paddingRight: 1,
          height: "45px",
          backgroundColor: "#FFF",
          color:
            selectedStatus === "draft"
              ? "#CC8552" // Color for draft
              : selectedStatus === "completed"
              ? "#7ABA56" // Color for completed
              : selectedStatus === "revoked"
              ? "#808080" // Color for revoked
              : "#999", // Default color for no status
          "& .MuiOutlinedInput-notchedOutline": {
            border: `2px solid ${
              selectedStatus === "draft"
                ? "#CC8552"
                : selectedStatus === "completed"
                ? "#7ABA56"
                : selectedStatus === "revoked"
                ? "#808080"
                : "#CCC"
            }`,
          },
          "& .MuiSvgIcon-root": {
            background:
              selectedStatus === "draft"
                ? "#CC8552"
                : selectedStatus === "completed"
                ? "#7ABA56"
                : selectedStatus === "revoked"
                ? "#808080"
                : "#CCC",
            borderRadius: 1,
            color: "#FFF",
          },
          "&:hover .MuiOutlinedInput-notchedOutline": {
            borderColor:
              selectedStatus === "draft"
                ? "#CC8552"
                : selectedStatus === "completed"
                ? "#7ABA56"
                : selectedStatus === "revoked"
                ? "#808080"
                : "#CCC",
          },
        }}
        renderValue={(value) => {
          if (!value) return "All";
          return (
            dropdownOptions.find((option) => option.value === value)?.label ||
            value
          );
        }}
      >
        {dropdownOptions.map((option) => (
          <MenuItem key={`dropdown-${option.value}`} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
      {showInfoText && (
        <Box sx={{ whiteSpace: "normal", fontSize: "11px", marginTop: "5px" }}>
          {selectedStatus !== "revoked"
            ? "(File will be available for the patient and others to view)"
            : "(Only available for clinicians or radiologists to view)"}
        </Box>
      )}
    </FormControl>
  );
};

export default StatusDropDownStatus;
